"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.stopListening = stopListening;
exports.useSharedWindowSize = useSharedWindowSize;
exports.useWindowSize = useWindowSize;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _react = require("react");
var _breakpoints = require("../../styles/breakpoints");
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var listeners;
var isListening = false;
var lastSize;
var getSize = function getSize(isClient) {
  lastSize = {
    width: isClient ? window.innerWidth : undefined,
    height: isClient ? window.innerHeight : undefined
  };
  return lastSize;
};
function useSharedWindowSize() {
  var isClient = (typeof window === "undefined" ? "undefined" : (0, _typeof2["default"])(window)) === 'object';
  startListening();
  var _useState = (0, _react.useState)(lastSize),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    windowSize = _useState2[0],
    setWindowSize = _useState2[1];
  (0, _react.useEffect)(function () {
    if (!isClient) {
      return null;
    }
    function handleResize(size) {
      setWindowSize(size);
    }
    addListener(handleResize);
    return function () {
      return removeListener(handleResize);
    };
  }, [isClient]);
  return _objectSpread(_objectSpread({}, getPayload(windowSize)), {}, {
    setWindowSize: setWindowSize
  });
}
var getBreakpoint = function getBreakpoint(width) {
  if (width === undefined) {
    return undefined;
  }
  if (width <= _breakpoints.breakpoints.small) {
    return 'xs';
  }
  if (width <= _breakpoints.breakpoints.medium) {
    return 'sm';
  }
  if (width <= _breakpoints.breakpoints.large) {
    return 'md';
  }
  if (width <= _breakpoints.breakpoints.xLarge) {
    return 'lg';
  }
  return 'xl';
};
function useWindowSize() {
  var isClient = (typeof window === "undefined" ? "undefined" : (0, _typeof2["default"])(window)) === 'object';
  var _useState3 = (0, _react.useState)(function () {
      return getSize(isClient);
    }),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    windowSize = _useState4[0],
    setWindowSize = _useState4[1];
  (0, _react.useEffect)(function () {
    if (!isClient) {
      return null;
    }
    function handleResize() {
      setWindowSize(getSize(isClient));
    }
    window.addEventListener('resize', handleResize);
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, [isClient]);
  return _objectSpread(_objectSpread({}, getPayload(windowSize)), {}, {
    setWindowSize: setWindowSize
  });
}
function addListener(cb) {
  listeners.add(cb);
}
function removeListener(cb) {
  listeners["delete"](cb);
}
function eventListener() {
  var size = getSize(true);
  var _iterator = _createForOfIteratorHelper(listeners),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var cb = _step.value;
      cb(size);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
}
function startListening() {
  var isClient = (typeof window === "undefined" ? "undefined" : (0, _typeof2["default"])(window)) === 'object';
  if (isListening) {
    return;
  }
  isListening = true;
  listeners = new Set();
  getSize(isClient);
  window.addEventListener('resize', eventListener);
}
function stopListening() {
  listeners = null;
  isListening = false;
  window.removeEventListener('resize', eventListener);
}
function getPayload(windowSize) {
  return {
    windowSize: windowSize,
    windowBreakpoint: getBreakpoint(windowSize.width),
    isUpToSmall: windowSize.width <= _breakpoints.breakpoints.small,
    isSmallUp: windowSize.width > _breakpoints.breakpoints.small,
    isMediumUp: windowSize.width > _breakpoints.breakpoints.medium,
    isLargeUp: windowSize.width > _breakpoints.breakpoints.large,
    isXLargeUp: windowSize.width > _breakpoints.breakpoints.xLarge,
    isLowHeight: windowSize.height < 800
  };
}
//# sourceMappingURL=useWindowSize.js.map